module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentst",
    attrs: {
      "id": "otherfm2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('strong', [_vm._v("No problem can be solved from the same"), _c('br'), _vm._v("level of consciousness that created it.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents1"
  }, [_vm._v("— "), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALBERT EINSTEIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("For peoples, generally, their story of the universe"), _c('br'), _vm._v("and the human role in the universe is their primary"), _c('br'), _vm._v("source of intelligibility and value. The deepest crises"), _c('br'), _vm._v("experienced by any society are those moments of"), _c('br'), _vm._v("change when the story becomes inadequate for"), _c('br'), _vm._v("meeting the survival demands of a present situation.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents1"
  }, [_c('strong', [_vm._v("— "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THOMAS BERRY")])]), _vm._v(", "), _c('strong', [_c('em', [_vm._v("The Dream of the Earth")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Let ours be a time remembered for the"), _c('br'), _vm._v("awakening of a new reverence for life.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents1"
  }, [_c('strong', [_vm._v("— "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE EARTH CHARTER")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25658bbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/otherfm2.vue
// module id = 81
// module chunks = 0